import React from 'react';

import { withConfig } from '../common/Block.jsx';
import { Clickable } from '../common/Button.jsx';
import { Column, Container, HeaderText, Row, Spaced } from '../common/Container.jsx';
import { withValidationV2 } from '../common/Form.jsx';
import { Required, Text, Wrapper as InputWrapper } from '../common/Input.jsx';
import Utilities from '../common/Utilities.jsx';

let _ContactFormInst;
class _ContactForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {}

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        _ContactFormInst = true;

        if (!window || !window.location || !window.location.search) {
            return;
        }
        const query = Utilities.parseQueryString(window.location.search.substring(1));
        if (!query) {
            return;
        }
        if (query.inventoryId) {
            this.props.onChange('Id', query.inventoryId);
        }
        if (query.message) {
            this.props.onChange('Message', query.message);
        }
        if (query.subject) {
            this.props.onChange('Subject', query.subject);
        }
    }

    componentDidUpdate() {
        if (!this.state.token && this.props.formData && this.props.formData.token) {
            this.setState({
                token: this.props.formData.token
            }, () => {
                const postData = {
                    Id: this.props.formData.Id,
                    Email: this.props.formData.Email,
                    Message: this.props.formData.Message,
                    Name: this.props.formData.Name,
                    Phone: this.props.formData.Phone,
                    Robots: this.props.formData.token,
                    Sub: this.props.config.subdomain,
                    Subject: this.props.formData.Subject
                }
                this.props.onSubmit('/api/contacts', postData);
            })
        }
    }

    componentWillUnmount() {
        _ContactFormInst = undefined;
    }

    handleSubmit() {
        if (this.props.formData.formState) {
            return;
        }
        this.props.onValidate();
    }

    render() {
        const embedList = [];
        let addressLineOne;
        if (this.props.config.addressLineOne && this.props.config.addressLineOne.length > 0) {
            addressLineOne = this.props.config.addressLineOne;
            embedList.push(encodeURIComponent(addressLineOne.replace('&', '')));
        }
        let addressLineTwo;
        if (this.props.config.addressLineTwo && this.props.config.addressLineTwo.length > 0) {
            addressLineTwo = this.props.config.addressLineTwo;
            embedList.push(encodeURIComponent(addressLineTwo.replace('&', '')));
        }
        let location;
        if (this.props.config.city && this.props.config.city.length > 0) {
            location = this.props.config.city;
        }
        if (this.props.config.state && this.props.config.state.length > 0) {
            if (!location) {
                location = this.props.config.state;
            } else {
                location += `, ${this.props.config.state}`;
            }
        }
        if (this.props.config.zip && this.props.config.zip.length > 0) {
            if (!location) {
                location = this.props.config.zip;
            } else {
                location += ` ${this.props.config.zip}`;
            }
        }
        if (location && location.length > 0) {
            embedList.push(encodeURIComponent(location.replace('&', '')));
        }
        let country;
        if (this.props.config.country && this.props.config.country.length > 0) {
            country = this.props.config.country;
            embedList.push(encodeURIComponent(country.replace('&', '')));
        }
        let embedQ;
        if (embedList.length > 0) {
            embedQ = embedList.join(',');
        }
        const hasContact = this.props.blockConfig.hasContactAddress || this.props.blockConfig.hasContactHours || this.props.blockConfig.hasContactMap;
        let content = (
            <Container className="cont--contact">
                <Spaced large={true}>
                    <Row className={hasContact ? undefined : 'cont--cent'}>
                        <Column size="8">
                            <form className="form form--contact">
                                <Row>
                                    <Column size="12">
                                        <InputWrapper size="large">
                                            <Required
                                                disabled={this.props.disabled}
                                                errors={this.props.formData.errors}
                                                name="Name"
                                                placeholder="Full Name *"
                                                value={this.props.formData.Name}
                                                onChange={this.props.onChange} />
                                        </InputWrapper>
                                    </Column>
                                    <Column size="6">
                                        <InputWrapper size="large">
                                            <Required
                                                disabled={this.props.disabled}
                                                errors={this.props.formData.errors}
                                                name="Email"
                                                placeholder="Email Address *"
                                                type="email"
                                                value={this.props.formData.Email}
                                                onChange={this.props.onChange} />
                                        </InputWrapper>
                                    </Column>
                                    <Column size="6">
                                        <InputWrapper size="large">
                                            <Text
                                                disabled={this.props.disabled}
                                                name="Phone"
                                                placeholder="Phone Number"
                                                value={this.props.formData.Phone || ''}
                                                onChange={this.props.onChange} />
                                        </InputWrapper>
                                    </Column>
                                    <Column size="12">
                                        <InputWrapper size="large">
                                            <Required
                                                disabled={this.props.disabled}
                                                errors={this.props.formData.errors}
                                                name="Subject"
                                                placeholder="Subject *"
                                                value={this.props.formData.Subject}
                                                onChange={this.props.onChange} />
                                        </InputWrapper>
                                    </Column>
                                    <Column size="12">
                                        <InputWrapper className="input--area" size="large">
                                            <Required
                                                cols="30"
                                                disabled={this.props.disabled}
                                                errors={this.props.formData.errors}
                                                name="Message"
                                                placeholder="Your Message..."
                                                rows="10"
                                                type="textarea"
                                                value={this.props.formData.Message}
                                                onChange={this.props.onChange} />
                                        </InputWrapper>
                                    </Column>
                                    <Column size="12">
                                        <div className="form--contact__foot">
                                            <Clickable
                                                className={`btn btn--outl btn--lg form__btn${this.props.buttonClassName}`}
                                                disabled={this.props.disabled}
                                                type="submit"
                                                onClick={this.handleSubmit}>
                                                <React.Fragment><div className="submission-status" /> {this.props.formData.formState == 'success' ? 'Message Sent' : 'Send message'}</React.Fragment>
                                            </Clickable>
                                        </div>
                                    </Column>
                                </Row>
                            </form>
                        </Column>
                        {
                            hasContact &&
                            <Column size="4">
                                {
                                    this.props.blockConfig.hasContactAddress &&
                                    <div className="sect__widg">
                                        <_HeaderText>Address</_HeaderText>
                                        <div className="sect--contact__info sect--contact__info--address">
                                            {
                                                addressLineOne &&
                                                <div>{addressLineOne}</div>
                                            }
                                            {
                                                addressLineTwo &&
                                                <div>{addressLineTwo}</div>
                                            }
                                            {
                                                location &&
                                                <div>{location}</div>
                                            }
                                            {
                                                country &&
                                                <div>{country}</div>
                                            }
                                            {
                                                this.props.config.phone != undefined &&
                                                this.props.config.phone.length > 0 &&
                                                <a href={`tel:${this.props.config.phone}`} style={this.props.builder ? { pointerEvents: 'none' } : undefined}>{this.props.config.phone}</a>
                                            }
                                        </div>
                                    </div>
                                }
                                {
                                    this.props.blockConfig.hasContactHours &&
                                    this.props.config.hours &&
                                    this.props.config.hours.length > 0 &&
                                    <div className="sect__widg">
                                        <_HeaderText>Hours</_HeaderText>
                                        <div className="sect--contact__info sect--contact__info--hours">
                                            {this.props.config.hours.map((d, i) => <div key={i}>{d}</div>)}
                                        </div>
                                    </div>
                                }
                                {
                                    this.props.blockConfig.hasContactMap &&
                                    embedQ &&
                                    embedQ.length > 0 &&
                                    <div className="sect__widg">
                                        <_HeaderText>Map</_HeaderText>
                                        <iframe
                                            allowFullScreen={true}
                                            frameBorder="0"
                                            height="450"
                                            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBIFIqcEzOREUZ6tiKjL1Rjw5gdYoZZbDM&q=${embedQ}&zoom=12`}
                                            style={{ border: 0, maxWidth: '100%', pointerEvents: (this.props.builder ? 'none' : 'unset') }}
                                            width="600"></iframe>
                                    </div>
                                }
                            </Column>
                        }
                    </Row>
                </Spaced>
            </Container>
        );
        if (this.props.onContent) {
            content = this.props.onContent(content)
        }
        return content;
    }
}
const ContactForm =
    withConfig(
        withValidationV2(
            _ContactForm,
            ['Email', 'Message', 'Name', 'Subject'],
            function () {
                if (window && window.gtag) {
                    gtag('event', 'subscribe', {
                        'method': 'page'
                    });
                }
                if (window && window.fbq) {
                    fbq('track', 'Lead');
                }
                if (window && window.pintrk) {
                    pintrk('track', 'lead', { 
                        lead_type: 'inquiry'
                    });
                }
            }));

function _HeaderText(props) {
    return <HeaderText className="sect__widg__header" innerClassName="sect__widg__header__inn">{props.children}</HeaderText>
}

export default ContactForm;